export default __webpack_public_path__ + "static/media/news1.b4dad29c.jpg";